<template>
    <div>
        <div class="header">
            <h3>{{ $t('change_password') }}</h3>
        </div>

        <el-card shadow="never">
            <el-form :model="model" status-icon label-width="270px">
                <el-form-item :label="$t('current_password')" prop="old_password" :error="error_form.old_password">
                    <el-input v-model="model.old_password" show-password></el-input>
                </el-form-item>
                <el-form-item :label="$t('new_password')" prop="new_password" :error="error_form.new_password">
                    <el-input v-model="model.new_password" show-password></el-input>
                </el-form-item>
                <el-form-item :label="$t('confirm_new_password')" prop="confirm_password" :error="error_form.confirm_password">
                    <el-input v-model="model.confirm_password" show-password></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="save" :loading="loading_form">{{ $t('save') }}</el-button>
                </el-form-item>
            </el-form>
        </el-card>

    </div>
</template>

<script>
    export default {
        name: "ChangePassword",
        data () {
            return {
                model: {},
                loading_form: false,
                error_form: {}
            };
        },
        methods: {
            save () {
                this.loading_form = true;
                this.$axios.post('/profile/change-password', this.model).then((res) => {
                    this.$store.commit('setToken', res.data.access_token);
                    this.$message.success(this.$t('notice.change_password_success'));
                    this.error_form = {};
                    this.loading_form = false;
                }).catch((error) => {
                    this.error_form = error.response.data;
                    this.loading_form=false;
                });
            }
        }
    }
</script>

<style scoped>

</style>